import React from "react";
import Box from "@mui/material/Box";
import StyledPopup from "../StyledPopup/StyledPopup";
import {Grid, Typography} from "@mui/material";
import TransparentButton from "../TransparentButton/TransparentButton";
import {useTheme} from "../../../contexts/theme";


interface StyledConfirmationDialogProps {
    onClose : () => void;
    onConfirm: () => void;
    onDeny: () => void;
    message: string;
    open: boolean;
}


const StyledConfirmationDialog : React.FC<StyledConfirmationDialogProps> = ({onClose, onConfirm,onDeny, open, message}) => {

    const theme = useTheme()


    return (
        <StyledPopup isOpen={open} onClose={onClose} width={'40%'}>
            <Box sx={{
                marginTop: theme.spacing.sm,
                width: '100%',
                border: `1px solid ${theme.palette.lightGrey}`,
                borderRadius: theme.spacing.xs,
                padding: theme.spacing.md,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                <Box sx={{
                    width: '100%',
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Typography variant="h6" gutterBottom
                                style={{color: theme.palette.white, textAlign: 'center'}}>{message}</Typography>
                    <Box
                        sx={{
                            display: "flex",
                            width: '100%',
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Grid container spacing={2} columns={12}>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <Box maxWidth={'150px'} sx={{ marginLeft: 'auto' }} >
                                    <TransparentButton text={"Yes"} width={'100%'} onClick={() => {
                                        onConfirm()
                                        onClose()
                                    }}/>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <Box maxWidth={'150px'}>
                                    <TransparentButton text={"No"} width={'100%'}  onClick={() => {
                                        onDeny()
                                        onClose()
                                    }}/>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </StyledPopup>)
}

export default StyledConfirmationDialog;